import Debts from '@/models/loyaltyPanel/BranchDebt';
const getDefaultState = () => ({
  items: [],
  redemptionInvoice: [],
  smsMetrics: [],
  viberMetrics: [],
});
export default {
  namespaced: true,

  state: () => getDefaultState(),

  mutations: {
    resetState(state) {
      Object.assign(state, getDefaultState());
    },

    setDebts(state, payload) {
      state.items = payload;
    },

    setRedemptionInvoice(state, payload) {
      state.redemptionInvoice = payload;
    },

    setSmsMetrics(state, payload) {
      state.smsMetrics = payload;
    },

    setViberMetrics(state, payload) {
      state.viberMetrics = payload;
    },
  },

  actions: {
    async getDebts({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });

        const { data } = await Debts.get(body.query, filter);

        const debts = data.data.data;
        const pagination = data.data.pagination;

        commit('setDebts', debts);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getMonthlyPoints({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });
        console.log('sadfdsasdasdasdadsasdasdasda');
        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });

        const { data } = await Debts.getMonthlyPoints(body.query, filter);

        const debts = data.data.data;
        const pagination = data.data.pagination;

        commit('setDebts', debts);
        commit('setServerItemsLength', pagination.total, {
          root: true,
        });
        commit('setServerPagination', pagination, {
          root: true,
        });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getRedemptionInvoice({ commit }, body) {
      try {
        commit('setLoading', true, { root: true });

        let filter = '';
        Object.keys(body.filters).map((key) => {
          if (body.filters[key]) {
            filter += '&' + key + '=' + body.filters[key];
          }
        });

        const { data } = await Debts.getRedemptionInvoice(body.query, filter);

        const debts = data.data;
        // const pagination = data.data.pagination

        commit('setRedemptionInvoice', debts);
        // commit("setServerItemsLength", pagination.total, {
        //     root: true
        // });
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getSmsMetrics({ commit }, date) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Debts.getSmsMetrics(date);

        commit('setSmsMetrics', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },

    async getViberMetrics({ commit }, date) {
      try {
        commit('setLoading', true, { root: true });

        const { data } = await Debts.getViberMetrics(date);

        commit('setViberMetrics', data.data);
        commit('setLoading', false, { root: true });
      } catch (ex) {
        commit('setLoading', false, { root: true });
      }
    },
  },
};
